// TODO: 用这样的方式实现的判断会有点危险，依然存在 XSS 的风险
export function rmHtml(str: string) {
  return str ? str.replace(/<(.*?)>/g, '') : ''
}
